var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"color":"grey","size":_vm.size}},[(_vm.avatar)?[_c('pic',{attrs:{"path":_vm.avatar}})]:(_vm.initials)?[_c('span',{staticClass:"white--text"},[_vm._v(" "+_vm._s(_vm.initials)+" ")])]:[_c('v-icon',[_vm._v("mdi-account-outline")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }